import env from "../env/env";
export default function getStoreModuleByName(name) {
  return [env.name, env.prefix, name].join("_");
}
